!function () {

  // Hide Header on scroll down
  var didScroll = false;
  var lastScrollTop = 0;
  var delta = 5;
  var masthead = document.querySelector( '.masthead' );
  var navbarHeight = masthead.offsetHeight;


  window.addEventListener( 'scroll', function () {
    didScroll = true;
  } );

  setInterval( function () {
    if ( didScroll ) {
      hasScrolled();
      didScroll = false;
    }
  }, 250 );

  function hasScrolled () {
    var st = window.scrollY;
    const openSubmenu = document.querySelector( 'li.menu-item-has-children.sub-menu-open' );

    // Make sure they scroll more than delta
    if ( Math.abs( lastScrollTop - st ) <= delta ) {
      return;
    }

    // If they scrolled down and are past the navbar, add class .nav-hide.
    if ( st > lastScrollTop && st > navbarHeight ) {
      // Scroll Down
      masthead.classList.add( 'nav-hide' );
    } else {
      // Scroll Up
      if ( st + window.innerHeight < document.documentElement.scrollHeight ) {
        masthead.classList.remove( 'nav-hide' );
      }
    }

    if ( openSubmenu ) {
      openSubmenu.classList.remove( 'sub-menu-open' );
    }

    lastScrollTop = st;
  }

  // handle the masthead dropdown/megamenu
  let currentEl = null;
  let delay = 300;
  let menuEnterTimer, menuLeaveTimer;

  const onMenuItemEnter = ( el ) => {
    el.classList.add('sub-menu-open');
  }

  const onMenuItemLeave = ( el ) => {
    el.classList.remove( 'sub-menu-open' );
  }

  const removeAriaExpanded = ( el ) => {
    el.querySelectorAll( '[aria-expanded="true"]' ).forEach( ( ( e ) => {
      e.setAttribute( 'aria-expanded', 'false' )
    } ) )
  }
  const addAriaExpanded = ( el ) => {
    let nearest = el.target.closest( '[aria-expanded]' );
    if ( 'true' === nearest.getAttribute( 'aria-expanded' ) )
      removeAriaExpanded( nearest.closest( '.menu-item-has-children' ) );
    else {
      nearest.setAttribute( 'aria-expanded', 'true' )
    }
  }

  window.addEventListener( 'load', ( () => {

    document.querySelectorAll( 'li.menu-item-has-children' ).forEach( ( menuItem ) => {
      menuItem.addEventListener( 'mouseover', ( e ) => {
        // prevents active menu from clearing if re-entered quickly
        if ( e.target.classList.contains('sub-menu-open') ) {
          clearTimeout( menuLeaveTimer );
        }
        
        clearTimeout( menuEnterTimer );
        let target = e.target.closest( 'li.menu-item-has-children' );

        menuEnterTimer = setTimeout( () => {
          currentEl = target;
          onMenuItemEnter( currentEl );
        }, delay )
      } )

      menuItem.addEventListener( 'mouseout', ( e ) => {
        clearTimeout( menuLeaveTimer );

        // prevent fast mouse movements triggering menu
        if ( e.toElement !== currentEl ) {
          clearTimeout( menuEnterTimer );
        }

        menuLeaveTimer = setTimeout( () => {
          if ( !currentEl ) return;
          // check if mouseout to a descendant
          let relatedTarget = e.relatedTarget;

          while ( relatedTarget ) {
            // if we're still inside currentEl then ignore it
            if ( relatedTarget == currentEl ) return;
            relatedTarget = relatedTarget.parentNode;
          }
          onMenuItemLeave( currentEl );
          currentEl = null;
        }, 300 )
      } )
    } ), 
    document.querySelectorAll( '.menu-item-has-children button' ).forEach( ( ( e ) => {
      e.addEventListener( 'click', addAriaExpanded )
    }
    ) ),
    document.addEventListener( 'click', ( ( t ) => {
      document.querySelectorAll( '.masthead-navigation' ).forEach( ( n ) => {
        n.contains( t.target ) || removeAriaExpanded( n )
      } )
    }
    ) ),
    document.addEventListener( 'keyup', ( ( t ) => {
      document.querySelectorAll( 'li.menu-item-has-children' ).forEach( ( n ) => {
        if ( n.contains( t.target ) ) {
          if ( 'Escape' === t.key ) {
            const t = n.querySelector( '[aria-expanded="true"]' );
            removeAriaExpanded( n ),
            null == t || t.focus()
          }
        } else
          removeAriaExpanded( n )
      } )
    }
    ) )
  }
  ) )
}();
